export default __webpack_public_path__ + "static/media/companyMaintenance Screen.93b7d772.jpg";